export default "__VITE_ASSET__CqRuYakJ__"